import { axios, base } from '../http';

/**
 * 学校下可选校区
 * @param {Object} params { schoolId }
 */
export const getClassBuildingCampusOptions = (params) => {
  return axios.get(`${base}/api/ClassBuilding/GetCampusOptions`, { params });
};

/**
 * 班级楼栋分区概览
 * @param {Object} params { schoolId, campusId }
 */
export const getClassBuildingOverview = (params) => {
  return axios.get(`${base}/api/ClassBuilding/GetOverview`, { params });
};

/**
 * 新增或修改楼栋
 * @param {Object} data { id, schoolId, campusId, name, orderSort }
 */
export const saveClassBuilding = (data) => {
  return axios.post(`${base}/api/ClassBuilding/SaveBuilding`, data);
};

/**
 * 删除楼栋
 * @param {Object} params { schoolId, campusId, buildingId }
 */
export const deleteClassBuilding = (params) => {
  return axios.delete(`${base}/api/ClassBuilding/DeleteBuilding`, { params });
};

/**
 * 保存楼栋排序
 * @param {Object} data { schoolId, campusId, buildingIds }
 */
export const saveClassBuildingSort = (data) => {
  return axios.post(`${base}/api/ClassBuilding/SaveBuildingSort`, data);
};

/**
 * 划班入楼
 * @param {Object} data { schoolId, campusId, buildingId, departmentIds }
 */
export const assignClassBuildingClasses = (data) => {
  return axios.post(`${base}/api/ClassBuilding/AssignClasses`, data);
};

/**
 * 从楼栋移出班级
 * @param {Object} data { schoolId, buildingId, departmentIds }
 */
export const removeClassBuildingClasses = (data) => {
  return axios.post(`${base}/api/ClassBuilding/RemoveClasses`, data);
};

/**
 * 保存楼栋内班级排序
 * @param {Object} data { schoolId, buildingId, departmentIds }
 */
export const saveClassBuildingClassSort = (data) => {
  return axios.post(`${base}/api/ClassBuilding/SaveClassSort`, data);
};
